import React, { Component } from 'react';
import { connect } from 'react-redux';

import { navigate } from 'libs/router';

import ActionButton from 'components/buttons/action-button/ActionButton';
import Form from 'components/form/Form';
import FormField from 'components/form/form-field/FormField';
import Input from 'components/inputs/input/Input';

import RecaptchaTermsAndPolicy from '../RecaptchaTermsAndPolicy';

import { isEmail, isRequired } from 'utils/validators';
import { requestPasswordReset } from '../../reducers/passwordReset';

import { __t, applyTranslations } from 'utils/language';

import '../../common/access-form.scss';
import '../../common/access-actions.scss';
import './request-password-reset-form.scss';

applyTranslations(require('./request-password-reset-form.i18n.json'));

type Props = {
  dispatch: any
};

type State = {
  email: string
};

const MSG_KEY = 'request_password_reset_form';

class RequestPasswordResetForm extends Component<Props, State> {
  state = {
    email: ''
  };

  handleSubmit = (event) => {
    const { dispatch } = this.props;

    event.preventDefault();
    dispatch(requestPasswordReset({
      email: this.state.email,
      successMessage: __t(`${MSG_KEY}.reset_message`)
    }));
  };

  handleTextInput = (event) => {
    this.setState({
      email: event.target.value
    });
  };

  handleOnCancel = () => {
    // @ts-ignore ReactNativeWebView is object on react native webview
    if (window?.ReactNativeWebView?.postMessage) { // @ts-ignore
      window.ReactNativeWebView.postMessage('cancel');
    } else {
      navigate.to('/login');
    }
  };

  render() {
    return (
      <Form
        onSubmit={this.handleSubmit}
        className="access-form"
        data={{ qa: 'access-form' }}
      >
        <FormField
          label={__t(`${MSG_KEY}.email_label`)}
          validators={[
            isRequired(this.state.email),
            isEmail(this.state.email)
          ]}
          showValidationIcon={false}
        >
          <Input
            onChange={this.handleTextInput}
            name="email"
            value={this.state.email}
          />
        </FormField>
        <div className="access-actions__captcha">
          <RecaptchaTermsAndPolicy />
        </div>
        <div className="access-actions">
          <ActionButton
            color="tertiary"
            onClick={this.handleOnCancel}
          >
            {__t(`${MSG_KEY}.action_cancel`)}
          </ActionButton>
          <ActionButton
            type="submit"
          >
            {__t(`${MSG_KEY}.action_send_email`)}
          </ActionButton>
        </div>
      </Form>
    );
  }
}

export default connect()(RequestPasswordResetForm);
